// Components
import { Toast } from '@tracklib/kit'

// Types
import { UserSongState } from 'types'

// Utils
import { TRACKLIB_CONTACT_SUPPORT_PAGE } from '@constants'
import styles from './warningbox.css'

const getTitle = (state: string) => {
  switch (state) {
    case 'INCOMPLETE':
      return 'Your sample license is incomplete'
    case 'INVALID':
      return 'Your sample license is invalid'
    case 'TERMINATED':
      return 'Your sample license has been terminated'
    default:
      return ''
  }
}

const getDescription = (state: string) => {
  switch (state) {
    case 'INCOMPLETE':
      return 'This license is not active until you have completed the steps below.'
    case 'INVALID':
      return 'Contact support if you’ve got any questions.'
    case 'TERMINATED':
      return 'Contact support if you’ve got any questions.'
    default:
      return ''
  }
}

const getButtonUrl = (state: string, userSongId: number) => {
  const basePath = `/yoursongs/${userSongId}`
  switch (state) {
    case 'INVALID_REF':
      return `${basePath}/accounting`
    case 'INVALID':
      return TRACKLIB_CONTACT_SUPPORT_PAGE
    case 'TERMINATED':
      return TRACKLIB_CONTACT_SUPPORT_PAGE
    default:
      return ''
  }
}

const getButtonText = (state: string) => {
  switch (state) {
    case 'INVALID_REF':
      return 'Report revenue'
    case 'INVALID':
      return 'Contact support'
    case 'TERMINATED':
      return 'Contact support'
    default:
      return ''
  }
}

type WarningBoxProps = {
  userSongId: number
  state: UserSongState
}

const WarningBox = ({ state, userSongId }: WarningBoxProps): JSX.Element | null => {
  if (!state || state === 'UNLICENSED' || state === 'ACTIVE') {
    return null
  }
  // type={state !== 'INCOMPLETE' || state === 'INVALID' || (state === 'TERMINATED' && 'neutral')}
  return (
    <Toast
      className={styles.toast}
      title={getTitle(state)}
      description={getDescription(state)}
      buttonText={getButtonText(state)}
      buttonUrl={getButtonUrl(state, userSongId)}
      type="danger"
    />
  )
}

export default WarningBox
